import React from "react";
import Forbidden from "pages/AuthenticationInner/Forbidden";
import { moduleName } from "Components/constants/Common";

const ProtectedRoute = ({ path, element, permissions, routes }: any) => {
  const allowedModules = permissions?.map(
    ({ module_name }: any) => module_name
  );
  const route = routes?.find((r: any) => r.path === path);

  if (route) {
    if (
      Array.isArray(route?.module_name)
        ? route?.module_name.includes(moduleName.Public)
        : route?.module_name === moduleName.Public
    ) {
      return element;
    }

    const hasAccess = Array.isArray(route?.module_name)
      ? route?.module_name.some((module: any) =>
          allowedModules?.includes(module)
        )
      : allowedModules?.includes(route?.module_name);

    return hasAccess ? element : <Forbidden />;
  }

  return <Forbidden />;
};

export default ProtectedRoute;
